var createNativeStackNavigator = function createNativeStackNavigator2() {
  return {
    Navigator: function Navigator() {
      return null;
    },
    Screen: function Screen() {
      return null;
    }
  };
};
var NativeStackView = function NativeStackView2(_props) {
  return null;
};
export {
  NativeStackView,
  createNativeStackNavigator
};
//# sourceMappingURL=native-stack.js.map
